/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Acceptnda_Notice2Inputs */

const en_coinvestments_acceptnda_notice2 = /** @type {(inputs: Coinvestments_Acceptnda_Notice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept the NDA below to unlock the data room and terms`)
};

/**
* | output |
* | --- |
* | "Accept the NDA below to unlock the data room and terms" |
*
* @param {Coinvestments_Acceptnda_Notice2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_acceptnda_notice2 = /** @type {((inputs?: Coinvestments_Acceptnda_Notice2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Acceptnda_Notice2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_acceptnda_notice2(inputs)
});
export { coinvestments_acceptnda_notice2 as "coInvestments_acceptNda_notice" }